/**
 * Versión instalada, discreta en la esquina inferior derecha.
 *
 * Sirve para saber qué interfaz está viendo cada puesto: si tras actualizar
 * sigue saliendo la etiqueta anterior, el navegador conserva la versión vieja
 * (o la actualización no terminó). La fija `despliegue/actualizar.ps1` al
 * compilar, con la etiqueta de GitHub (`VITE_VERSION`); fuera de ese script vale
 * «desarrollo».
 *
 * No captura clics (`pointerEvents: none`): en la pantalla táctil de salidas no
 * debe interponerse con ningún botón.
 */

import Typography from '@mui/material/Typography'

const VERSION: string = import.meta.env.VITE_VERSION || 'desarrollo'

export function Version() {
  return (
    <Typography
      variant="caption"
      aria-hidden
      sx={{
        position: 'fixed',
        right: 12,
        bottom: 6,
        color: 'text.disabled',
        fontSize: '0.7rem',
        pointerEvents: 'none',
        userSelect: 'none',
        zIndex: (tema) => tema.zIndex.snackbar,
        '@media print': { display: 'none' },
      }}
    >
      {VERSION}
    </Typography>
  )
}
